const AiChatLoadingNames = {
  GENERATING: "generating",
  REGENERATING: "regenerating"
};

export default AiChatLoadingNames;
